<template>
	<div class="header">
		<router-link to="/mobilindex"  class="logo">
			<img src="../assets/icon.png" alt="">
		</router-link>
		<router-link to="/wxh5/mobilrecharging" class="toCharge"></router-link>
		<!-- <router-link to="/wxh5/mobilrecharging" class="toCharge"></router-link> -->
	</div>
</template>
<script>
	export default {
		name: 'mobileHeader',
		data () {
			return {
			}
		},
		computed:{

		},
		created:function() {
		}
	}
</script>
<style scoped>
	.header{
		width:100%;
		position:absolute;
		top: 0;
		box-sizing: border-box;
		padding: 15px 5%;
		z-index: 9;
	}


	.logo img{
		float: left;
		height: 30px;
	}

	.toCharge{
		float: right;
		background: url("../assets/recharge.png") no-repeat;
		width: 80px;
    height: 30px;
		background-size: 100%;
	}

	.toCharge:active{
		opacity: .8;
		background-size: 100%;
	}
	@media (min-width:768px) {
		.logo img{
			float: left;
			height: 55px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/mobilComponents/mobilHeader.vue